import { Children, isValidElement, type ReactElement, type ReactNode } from "react";

export const transformChildrenToString = (children: ReactNode | ReactNode[]): string => {
  if (!Array.isArray(children) && !isValidElement(children)) {
    return childToString(children);
  }

  return (
    Children.map(children, (child) => {
      if (hasChildren(child)) {
        return transformChildrenToString(child.props.children);
      }

      if (isValidElement(child)) {
        return "";
      }

      return childToString(child);
    })?.join("") ?? ""
  );
};

const childToString = (child?: ReactNode): string => {
  if (typeof child === "undefined" || child === null || typeof child === "boolean") {
    return "";
  }

  if (JSON.stringify(child) === "{}") {
    return "";
  }

  return child.toString();
};

const hasChildren = (
  element: ReactNode
): element is ReactElement<{ children: ReactNode | ReactNode[] }> =>
  isValidElement<{ children?: ReactNode[] }>(element) && Boolean(element.props.children);
